import PropTypes from 'prop-types';
import React from 'react';
import { Button, Form, Row, Col, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Formik } from 'formik';
import * as Yup from 'yup';

import loginService from '../loginService';
import logo from '../../../img/logo.svg';
import swal from 'sweetalert';

const LoginService = new loginService();

const ResetPassword = ({ location, history }) => {
    const token = new URLSearchParams(location.search).get('token');

    return (
        <Formik
            initialValues={{
                newPassword: '',
                newPasswordRepeated: '',
            }}
            validationSchema={Yup.object({
                newPassword: Yup.string()
                    .required('No password provided.')
                    .min(8, 'Password is too short - should be 8 chars minimum.'),
                newPasswordRepeated: Yup.string()
                    .required('Required')
                    .required('No password confirmation provided.')
                    .min(8, 'Password is too short - should be 8 chars minimum.')
                    .oneOf([Yup.ref('newPassword')], 'Passwords do not match.'),
            })}
            onSubmit={async ({ newPassword, newPasswordRepeated }) => {
                try {
                    var res = await LoginService.resetPassword(token, newPassword, newPasswordRepeated);
                    if (res && res.status === 'Failure') {
                        swal({
                            title: 'Password reset failed',
                            text: res.message,
                            icon: 'error',
                            button: 'OK',
                        });
                    } else {
                        swal({
                            title: res.status,
                            text: 'Your password has successfully been reset.',
                            icon: 'success',
                            button: 'OK',
                        }).then(() => {
                            history.push('/login');
                        });
                    }
                } catch (err) {
                    console.log(err);
                }
            }}
        >
            {(formik) => {
                return (
                    <div className="content-box">
                        <Container className="p-4 mt-3">
                            <img className="branding-login" src={logo} alt="Therigy Logo" />
                        </Container>
                        {/* Container for reset form */}
                        <Container className="p-4 mt-3 log-box shadow">
                            <form className="form-change-password" onSubmit={formik.handleSubmit}>
                                <Form.Row>
                                    <Col md={12}>
                                        <Form.Group>
                                            <label htmlFor="newPassword">New Password</label>
                                            <input
                                                className="form-control"
                                                id="newPassword"
                                                name="newPassword"
                                                type="password"
                                                placeholder="New Password"
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={formik.values.newPassword}
                                            />
                                            {formik.touched.newPassword && formik.errors.newPassword ? (
                                                <div className="error">{formik.errors.newPassword}</div>
                                            ) : null}
                                        </Form.Group>
                                    </Col>
                                </Form.Row>
                                <Form.Row>
                                    <Col md={12}>
                                        <Form.Group>
                                            <label htmlFor="newPasswordRepeated">Confirm New Password</label>
                                            <input
                                                className="form-control"
                                                id="newPasswordRepeated"
                                                name="newPasswordRepeated"
                                                type="password"
                                                placeholder="Confirm New Password"
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={formik.values.newPasswordRepeated}
                                            />
                                            {formik.touched.newPasswordRepeated && formik.errors.newPasswordRepeated ? (
                                                <div className="error">{formik.errors.newPasswordRepeated}</div>
                                            ) : null}
                                        </Form.Group>
                                    </Col>
                                </Form.Row>
                                <Row className="mt-3">
                                    <Col md={6} className="pt-2">
                                        <Form.Group controlId="formBasicPassword" className="m-0">
                                            <Form.Text className="forgot-password">
                                                <Link to="/login">Back to Sign in</Link>
                                            </Form.Text>
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Button type="submit" size="lg" block color="success">
                                            Reset Password
                                        </Button>
                                    </Col>
                                </Row>
                            </form>
                        </Container>
                    </div>
                );
            }}
        </Formik>
    );
};

ResetPassword.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func,
    }).isRequired,
    location: PropTypes.shape({
        search: PropTypes.string,
    }).isRequired,
};

export default ResetPassword;
